<template>
  <div>
    <link rel="icon" href="http://example.com/favicon.png">
    <div>
      <router-view />
    </div>
    
  </div>
</template>

<script>

export default {
  name: 'App',
  components:{
  }
}
</script>

<style>

</style>
